import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UtilityService } from '../util/utility.service';


class PolygonLatLng {
	
	lat: number;
	lng: number;

	constructor(lat: number, lng: number) {
		this.lat = lat;
		this.lng = lng;
	}

	isEqual(lat: number, lng: number) {
		return this.lat === lat && this.lng === lng;
	}
}


interface Polygon {
	polygon_id: string;
	coordinates_list: Array<PolygonLatLng>;
	name: string;
	status: string;
}

interface PolygonAPIResponse {
	result: Polygon[],

	meta: {
		code: 200;
		message: string;
		status: string;
	}
}


@Injectable({
	providedIn: 'root'
})
export class PolygonAPIService {

	private base_url: string = 'https://api.box8.co.in/customers/polygons/get_polygons';
	static MIN_DISTANCE: number = 100;
	
	constructor(
		private http: HttpClient,
		private utility: UtilityService
	) { }


	async fetchPolygons(lat: number, lng: number): Promise<PolygonAPIResponse> {

		// check cached response

		const response: any = await lastValueFrom(this.http.get(`${this.base_url}?lat=${lat}&lng=${lng}`, {
			headers: this.utility.getAuthHeaders()
		}));


		return response;
	}
}
